import { CLIENT_CACHE_KEY } from '../enum/index';
import { logErrorSprintf } from '../utils/utils';
export class VisitorProfileCache {
    _sdkConfig;
    constructor(sdkConfig) {
        this._sdkConfig = sdkConfig;
    }
    saveVisitorProfile(visitorProfile) {
        try {
            if (!visitorProfile) {
                localStorage.removeItem(CLIENT_CACHE_KEY);
                return;
            }
            localStorage.setItem(CLIENT_CACHE_KEY, JSON.stringify(visitorProfile));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }
        catch (error) {
            logErrorSprintf(this._sdkConfig, 'VisitorProfileCache.saveVisitorProfile', error?.message);
        }
    }
    loadVisitorProfile() {
        try {
            const data = localStorage.getItem(CLIENT_CACHE_KEY);
            return data ? JSON.parse(data) : null;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }
        catch (error) {
            logErrorSprintf(this._sdkConfig, 'VisitorProfileCache.loadVisitorProfile', error?.message);
        }
        return null;
    }
}
